import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { CommonService } from '../../../services/student-services/common/common.service';
import { Location } from '@angular/common';
import { SidebarService } from '../../../services/student-services/common/sidebar.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnChanges {
  @Output() activeTask = new EventEmitter<any>();
  @Input() sidebarInput;
  @Input() currentData;
  @Input() studentData;
  @Input() HUD;
  @Input() currentPage;
  @Output() navigation = new EventEmitter<string>();
  @Input() viewOnlyFlag;

  public settingsEnddate;
  public onTrack;
  public percentageCompleted = 0;
  togglePanel: any = {};
  public selectedTask;
  public selectedPhase;
  public activeView = {
    phase: '',
    task: ''
  };
  public tofixed: number;

  sideBarData: boolean;
  showSidebar: boolean = false;


  constructor(
    private readonly common: CommonService,
    private readonly location: Location,
    private readonly sidebarService: SidebarService
  ) { }
  legalDisclaimer = false;

  ngOnInit() {
    this.sidebarService.isSidebarActive.subscribe((isSidebarData: boolean) => {
      this.sideBarData = isSidebarData;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getProgressInfo();
  }

  public getProgressInfo() {
    if (!this.viewOnlyFlag) {
      this.HUD.percentageHUD = this.common.percentComplete(this.studentData.user_subtasks);
      this.HUD.pacingText = this.common.pacingText(this.studentData, this.studentData.user_subtasks);
      this.common.setEndDate(this.studentData.end_date);
      this.common.endDateCheck.subscribe(value => {
        this.settingsEnddate = value;
      });
    }
  }


  public togglePhase(phase) {
    if (this.currentData.phase) {
      if (this.currentData.phase === phase.contentful_id) {
        this.currentData.phase = ''
      } else {
        this.currentData.phase = phase.contentful_id;
      }
    } else {
      this.currentData.phase = phase.contentful_id;
    }
  }


  public showTaskDetails(task, phase) {
    this.sidebarService.isSidebarActive.next(this.showSidebar);
    if ( this.viewOnlyFlag === true) {
      this.location.replaceState('/checklist');
    } else {
      this.location.replaceState('/student');
    }
    this.currentData.task = task.contentful_id;
    this.selectedTask = task;
    this.selectedPhase = phase;
    this.activeTask.emit(this.selectedTask);

  }

  public changeGoal(path) {
    this.location.replaceState(`/${path}`);
    this.navigation.emit(path);
  }

  public sideDate() {
  }

  // to display the disclaimer pop-up
  public legalClick() {
    this.legalDisclaimer = true;
  }

  public closeModal() {
    this.legalDisclaimer = false;
  }

}
